export default __webpack_public_path__ + "static/media/phone.35f20b47.png";